import { WeekDays } from 'dash-common';
import { FormState } from 'dash-ui';
import get from 'lodash/get';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';

import { FormFields } from './AccountInfoForm.constants';

type TWorkingHours = Record<
  string,
  { from: string; to: string; __typename: string }
>;

export const getExistedWorkingHours = (workingHours: TWorkingHours) => {
  const existedWorkingHours = Object.entries(workingHours || {}).reduce(
    (memo, [key, value]) => {
      if (value) {
        const { __typename, ...rest } = value;

        return {
          ...memo,
          [key]: rest,
        };
      }
      return memo;
    },
    {}
  );

  return existedWorkingHours;
};

const compareWorkingHours = (
  currentWorkingHours: TWorkingHours,
  savedWorkingHours: TWorkingHours
) => {
  const fieldsToPick = Object.values(WeekDays);

  const existedCurrentWorkingHours =
    getExistedWorkingHours(currentWorkingHours);
  const existedSavedWorkingHours = getExistedWorkingHours(savedWorkingHours);

  const currentWorkingHoursToCompare = pick(
    existedCurrentWorkingHours,
    fieldsToPick
  );
  const savedWorkingHoursToCompare = pick(
    existedSavedWorkingHours,
    fieldsToPick
  );

  return isEqual(currentWorkingHoursToCompare, savedWorkingHoursToCompare);
};

export const compareFormData = (formData: FormState, initialValues: any) => {
  const fieldsToPick = [
    FormFields.FirstName,
    FormFields.LastName,
    FormFields.BrokerLicenseNumber,
    FormFields.PhoneNumber,
    FormFields.PhoneNumberDialCode,
    FormFields.AgencyName,
    FormFields.AgencyWebsite,
    FormFields.ShortDescription,
    FormFields.State,
  ];

  const pickedFormData = {
    ...pick(formData, fieldsToPick),
    placeId: get(formData, 'place.placeId'),
    avatarId: get(formData, 'avatar._id'),
  };
  const pickedInitialValues = {
    ...pick(initialValues, fieldsToPick),
    placeId: get(initialValues, 'place.placeId'),
    avatarId: get(initialValues, 'avatar._id'),
  };

  return (
    isEqual(pickedFormData, pickedInitialValues) &&
    compareWorkingHours(formData.workingHours, initialValues.workingHours) &&
    !formData.verifyPhoneNumberCode
  );
};
